import { useEffect } from "react";
import { useContent } from "./ContentContext";
import { applyTheme } from "./theme";

// Applies the CMS-configured brand palette to CSS variables at runtime.
export const ThemeInjector = () => {
  const { settings } = useContent();
  useEffect(() => {
    applyTheme(settings.theme || {});
  }, [settings.theme]);
  return null;
};
